/**
 * Tabs plugin that take care of touch scroll events and animation on mobile.
 * @param {jQuery Object} element
 * @param {Object} options
 *
 */
var tabs = function(element, options) {

    var _defaults = {
        namespace: 'tabs'
    }

    var widget = this;

    widget.options =  $.extend({}, _defaults, options || {});
    widget._init();
};

/**
 * Initialize method.
 *
 */
tabs.prototype._init = function() {
    var widget = this;
    $('body').on('init.zf.tabs', widget._bindWindowEvents);
};

tabs.prototype._bindWindowEvents = function(event) {
    var element = $(event.target);
    var widget = this;
    widget.lastHash = null;

    $(window).on('hashchange', openTabByLocationHash);

    element.on('change.zf.tabs', function(event, element) {
        widget.lastHash = element.children('a').attr('href')
    });

    function openTabByLocationHash() {
        var id = window.location.hash;
        var tab = element.find('[href$="' + id + '"]');
        if (tab.length === 0) {
            return;
        }
        if (id === widget.lastHash && element.find('[href$="' + id + '"]').attr('role') === 'tab') {
            return;
        }
        if (id) {
            var ele = $(id);
            if (ele) {
                element.foundation('selectTab', ele);
                widget.lastHash = id;
            }
        }
    }

    openTabByLocationHash();
}

export default tabs;
